export default __webpack_public_path__ + "static/media/Frame 6970.af4309e5.png";